/** Cibles de désignation de la vue de l'ordre (`data-attention`, components/attention.ts). */

/** « Rouvrir » : action attendue avant de régénérer un ordre finalisé. */
export const ORDER_REOPEN = "order-reopen";
